/**
 * designTokens — the small shared token module for the customer-facing
 * rate-gate + one-page booking surfaces (BlurCards gate card, DiscountBanner,
 * booking/confirm/*). Values are lifted from the app's existing palette
 * (primary blue, PF navy, grounds) so the new surfaces sit on-brand next to
 * the antd 3.x components. Keep this module dependency-free and additive —
 * legacy screens keep their inline styles.
 */

export const color = Object.freeze({
  /** Primary action blue (matches code_config primaryColor default). */
  primary: 'rgb(30,148,241)',
  primarySoft: '#eaf5fe',
  /** PF navy — headings / emphasis. */
  navy: '#17154e',
  /** Page + panel grounds. */
  ground: '#f5f7fa',
  groundAlt: '#eff3f7',
  /** Body text + secondary text. */
  ink: '#2c3540',
  ink2: '#6b7480',
  /** Hairlines. */
  line: '#d6dde6',
  lineSoft: '#e8edf3',
  /** Success (discount banner). */
  ok: '#2f9e63',
  okSoft: '#e8f7ef',
  okLine: '#bfe6cf',
  /** Inline validation / retryable error. */
  danger: '#c0392b',
  dangerSoft: '#fdf0ee',
});

/** antd-3-compatible geometry. */
export const radius = Object.freeze({
  base: '4px',
  card: '6px',
});

export const shadow = Object.freeze({
  card: '0 1px 3px rgba(23,21,78,.08)',
  overlay: '0 6px 24px rgba(23,21,78,.18)',
});

/**
 * 200ms ease micro-transition. Pair with `reducedMotion` in any styled block
 * that animates, so prefers-reduced-motion users get instant state changes.
 */
export const transition = 'all 200ms ease';

export const reducedMotion = `
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

/** Visible focus ring for keyboard users (never remove outlines silently). */
export const focusRing = `
  outline: none;
  border-color: ${color.primary};
  box-shadow: 0 0 0 3px rgba(30, 148, 241, 0.18);
`;

/** Comfortable tap target for touch (Apple HIG minimum). */
export const tapTarget = '44px';
